Namespace 'Settings.Models.AccountSettings.SocialAccounts'

class Settings.Models.AccountSettings.SocialAccounts.Microsoft365Account extends Backbone.Model
  urlRoot: 'save'

  defaults:
    uid: '',
    name: ''